// Rearranging .bra-size filters, specifically .cup-size and .band-size

jQuery(function($)
{
    var
        $body = $('body'),
        $container = $('#sidebar .filter-container', $container);

    if (0 === $container.length)
    {
        return;
    }

    function arrangeBraSizes()
    {
        if (1 >= $('.bra-size', $container).length)
        {
            return;
        }

        var $cupSize = $('.cup-size', $container);

        $('.band-size', $container).after($cupSize);		// Cup-Size nach band-size verschieben
        $('.bra-size', $container).eq(1)
            .remove();
    }

    function handleFiltersMarkupReplaced()
    {
        arrangeBraSizes();
    }

    arrangeBraSizes();
    $body.on(orion.constants.EventFiltersMarkupReplaced, handleFiltersMarkupReplaced);
});
